import { Link, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";

export default function UserNotRegisteredError() {
  const { slug } = useParams();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-6 px-4" dir="rtl">
      <div className="max-w-md w-full p-8 bg-card rounded-2xl border border-border text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 mb-6 rounded-full bg-amber-100 dark:bg-amber-900/30">
          <ShieldAlert className="w-8 h-8 text-amber-600 dark:text-amber-400" />
        </div>
        <h1 className="text-xl font-bold text-foreground mb-3">الوصول مقيّد</h1>
        <p className="text-muted-foreground text-sm mb-6">
          لا يمكنك الوصول لهذا المحتوى. تأكد من تسجيل الدخول بالحساب الصحيح.
        </p>
        <div className="flex flex-col gap-3">
          {slug && (
            <Link to={`/${slug}`}>
              <Button variant="outline" className="w-full">العودة للأكاديمية</Button>
            </Link>
          )}
          <Link to="/login">
            <Button className="w-full">تسجيل الدخول</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
